import { action as apiAction } from 'api/Api'
import {
  removeItem as removeItemFromElement
} from '../redux/elements'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  documentListItemId: number
  documentListId: number
}

const requestRemoveDocumentFromList = (payload: Payload) => async dispatch => {
  const { documentListItemId, documentListId } = payload

  const optimisticAction = optimisticDispatch(dispatch, removeItemFromElement({
    elementId: documentListId,
    itemId: documentListItemId
  }))

  try {
    await apiAction('RemoveDocumentsListItem', {
      containerId: documentListId,
      id: documentListItemId
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    throw error
  }
}

export default requestRemoveDocumentFromList
